<template>
  <div>
    <button :class="toggled? 'mr-0 btn btn-plm-toolbar-selected' : 'mr-0 btn btn-plm-toolbar-secondary' "
            style="width: 42px"
            type="button"
            v-if="buttonsOnSideMenu" ref="togglerBtn" @click="toggle" @focusout="onFocusLost"
            @keydown="onKeyDown">
      <font-awesome-icon v-if="toggled" :icon="['fad', 'ellipsis-h']"></font-awesome-icon>
      <font-awesome-icon v-else :icon="['fad', 'ellipsis-v' ]"></font-awesome-icon>
    </button>

    <div :style="mainDivStyle">
      <div v-if="toggled" :style="secondaryDivStyle">
        <b-container class="pr-1 pl-2 py-2 right-toolbar toolbars-bg">
          <b-row class="pt-1 no-gutters" v-for="button in toolbox" :key="button.id" v-if="button.onSidebar">
            <b-col>
              <side-menu-button :toolbox-button="button" @executed="hide" @focusout="onFocusLost"
                                @escape="hide"
                                @keydown="onKeyDown"></side-menu-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
    <div ref="headerBar" :class="toolboxHeaderBarClass" class="pl-1" :style="toolboxHeaderBarStyle">
      <div v-for="button in headerContent" :key="button.id" :class="headerContentClass" style="display: inline">
        <div v-if="button.type === 'group'" :class="groupClass" role="group">
          <side-menu-button v-for="inGroupBtn in button.items" :key="inGroupBtn.id" :toolbox-button="inGroupBtn"
                            @focusout="onFocusLost"
                            @executed="hide"
                            @escape="hide"
                            @keydown="onKeyDown">

          </side-menu-button>
        </div>
        <side-menu-button v-else :toolbox-button="button" class="mr-1" @executed="hide" @focusout="onFocusLost"
                          @keydown="onKeyDown"></side-menu-button>
      </div>
      <div v-if="downloadingBrandingZip.val" class="text-primary font-weight-bold h6" style="display: inline"><p
          class="mobile-text">Downloading </p>
        <font-awesome-icon :icon="['fad', 'spinner-third']" spin/>
      </div>
      <div v-if="downloadingBrandingZip.error" class="text-danger font-weight-bold h6" style="display: inline"><p
          class="mobile-text">Error downloading zip file. Try again later</p>
        <font-awesome-icon :icon="['fas', 'exclamation']"/>
      </div>
    </div>
  </div>
</template>

<script>
import SideMenuButton from "@/components/navbar/SideMenuButton";
import {addListener, removeListener} from "resize-detector";
import BaseFormConfig from "@/server/com/silkplm/engine/forms/schema/BaseFormConfig";
import BudgetingPlanner from "@/server/com/silkplm/model/plm/BudgetingPlanner";
import BudgetingPlannerPM from "@/server/com/silkplm/model/plm/BudgetingPlannerPM";

export default {
  name: "SideMenuToggle",
  components: {SideMenuButton},
  created() {
    this.setup();
  },
  mounted() {
    if (this.handler) {
      this.handler();
    }
    this.componentMounted = true;
  },

  destroyed() {
    removeListener(this.fillerBox, this.handler);
    while (this.fillerBox.firstChild) {
      this.fillerBox.removeChild(this.fillerBox.firstChild);
    }
  },
  methods: {
    onFocusLost(/** FocusEvent*/ focusEvent) {
      let el = focusEvent.relatedTarget;
      while (el) {
        if (el === this.$el) {
          return;
        }
        el = el.parentElement;
      }
      this.hide();
    },
    onKeyDown(ev) {
      let key = ev.keyCode || ev.charCode;

      if (key == 27) {
        this.hide();
      }
    },

    toggle() {
      this.toggled = !this.toggled;
    },

    checkFocus() {
      let el = document.activeElement;
      while (el) {
        if (el === this.$el || el.id === "left-menu-toggle-button") {
          return;
        }
        el = el.parentElement;
      }
      this.hide();
    },


    connectFillerBox(filler) {
      this.fillerBox = filler;
      this.setup();
    },

    setup() {
      if (!this.fillerBox || this.setupDone || !this.toolbox || !this.toolbox.length) {
        return;
      }
      this.fillerBox.appendChild(this.$refs.headerBar);
      this.$refs.headerBar.classList.remove("d-none");
      this.$refs.headerBar.classList.add("d-block");
      // this.setupDone = true;

      this.handler = () => {
        setTimeout(() => {
          let buttonsOnSideMenu = false;
          let limit = this.fillerBox.offsetWidth;
          if (this.$refs.togglerBtn) {
            limit += this.$refs.togglerBtn.offsetWidth;
          }

          let i = 0;
          let currentGroupName = "";

          for (let btn of this.toolbox) {
            if (!btn.group || (btn.group && btn.group !== currentGroupName)) {
              i += 4;
            }
            currentGroupName = btn.group;
            i += 42;
          }

          let allFit = i <= limit;

          limit = this.fillerBox.offsetWidth;
          if (allFit) {
            if (this.$refs.togglerBtn) {
              limit += this.$refs.togglerBtn.offsetWidth;
            }

            this.buttonsOnSideMenu = false;
          } else {
            if (!this.$refs.togglerBtn) {
              limit -= 42;
            }

            this.buttonsOnSideMenu = true;
          }

          i = 0;
          currentGroupName = "";
          let groupItems = [];
          const margin = 4;

          let headerContent = [];
          for (let btn of this.toolbox) {
            if (btn.group && btn.group === currentGroupName) {
              btn.onHeadbar = allFit || (i + 42 < limit);
            } else {
              btn.onHeadbar = allFit || (i + 42 + margin < limit);
            }
            btn.onSidebar = !btn.onHeadbar;
            buttonsOnSideMenu = buttonsOnSideMenu || btn.onSidebar;

            if (btn.onHeadbar) {
              if (btn.group && btn.group === currentGroupName) {
                groupItems.push(btn);
                i += 42
                continue
              }

              // close existing group if any
              if (btn.group !== currentGroupName && currentGroupName) {
                if (groupItems.length === 1) {
                  headerContent.push(groupItems[0]);
                } else {
                  headerContent.push({
                    type: 'group',
                    id: currentGroupName,
                    items: groupItems
                  });
                }
                groupItems = [];
                currentGroupName = "";
              }
              // start new group if needed
              if (btn.group) {
                i += 42 + margin;
                groupItems.push(btn);
                currentGroupName = btn.group;
                continue;
              }
              // just a button
              headerContent.push(btn);
              i += 42 + margin;
            }
          }
          // close last group if needed
          if (currentGroupName) {
            if (groupItems.length === 1) {
              headerContent.push(groupItems[0]);
            } else {
              headerContent.push({
                type: 'group',
                id: currentGroupName,
                items: groupItems
              });
            }
          }
          this.headerContent = [...headerContent];
          this.buttonsOnSideMenu = buttonsOnSideMenu;
          if (!buttonsOnSideMenu) {
            this.$emit('toggle-changed', false);
            this.toggled = false;
          }
          setTimeout(() => {
            this.loadDynamicStyles();
          })
        })
      }
      if(!this.listenerAdded) {
        this.listenerAdded = true;
        addListener(this.fillerBox, this.handler);
      }
      if (this.componentMounted) {
        this.$nextTick(() => this.handler());
      }
    },
    hide() {
      this.$emit('toggle-changed', false);
      this.toggled = false;
    },
    loadDynamicStyles() {
      setTimeout(() => {
        this.mainDivStyle = "position: relative; width: 0px; height: 0px";
        this.secondaryDivStyle = "position: absolute; z-index: 10000; right:-46px; top:4px;";
        this.toolboxHeaderBarStyle = "overflow-x: visible; width: 1000px";
        this.toolboxHeaderBarClass = "pt-1 p-0 m-0 d-block";
        this.headerContentClass = "";
        this.groupClass = "btn-group pr-1";
        // this.$refs.headerBar.classList.remove("d-none");
        // this.$refs.headerBar.classList.add("d-block");
      });
    }

  },
  props: {
    toolbox: {default: null},
    form: {type: BaseFormConfig},
    downloadingBrandingZip: {default: false},
  },
  watch: {
    "toolbox": function () {
      this.setup();
    },
    downloadingBrandingZip: function (val) {
      this.$emit("update:downloadingBrandingZip", this.downloadingBrandingZip);
    },
  },
  data: () => ({
    toolboxHeaderBarStyle: "",
    toolboxHeaderBarClass: "",
    headerContentClass: "d-none",
    groupClass: "btn-group pr-1 d-none",
    toggled: false,
    fillerBox: null,
    setupDone: false,
    handler: null,
    buttonsOnSideMenu: true,
    headerContent: [],
    mainDivStyle: "",
    secondaryDivStyle: ""
  })
}
</script>

<style scoped>
.mobile-text {
  display: inline;
}

@media screen and (max-width: 400px) {
  .mobile-text {
    display: none;
  }
}
</style>